import {createContext, ReactNode, useContext} from 'react';

const AddressContext = createContext<String>('');

export function AddressProvider({address, children}: {address: string; children: ReactNode}) {
  return (
    <AddressContext.Provider value={(address || '').toLowerCase()}>
      {children}
    </AddressContext.Provider>
  );
}

export function useAddress() {
  return useContext(AddressContext);
}
